/**
 * Stock-Kennzeichnung in der Bestellliste (Spec 2026-10-04-stock-order-abruf.md, Teil 3): eine kleine Marke
 * "Stock" neben der Bestellnummer, solange die Bestellung als Stock Order markiert ist (`order.stockOrder`,
 * `order_extras.stock_order`). Reine Anzeige - kein Status, keine Spalte. NEUBAU ohne Bestandsvorbild;
 * Styles in `styles/neubau/stockMarke.css`. Mit dem Abruf (DSV-Sendung zugeordnet) verschwindet das Haekchen
 * und damit die Marke.
 */
import type { ReactNode } from "react";
import type { Order } from "../lib/types.ts";

export const STOCK_MARKE_TITEL = "Stock Order – liegt auf Lager, bis sie über eine DSV-Sendung abgerufen wird";

export function StockMarke({ order }: { order: Order }): ReactNode {
  if (order.stockOrder !== true) return null;
  return (
    <span className="stock-marke" title={STOCK_MARKE_TITEL}>
      Stock
    </span>
  );
}
